const watchHistoryConfig = {
  COMPLETED_THRESHOLD: 95, // %
  NO_DURATION_PERCENT_COMPLETED: 80,
}

export default watchHistoryConfig
